import { useState, useEffect } from "react";

// One row of a Takeoff Variables table (db/65_takeoff_variables.sql) —
// Label/Description are seeded metadata (not admin-editable, see
// sp_SaveTakeoffVariable's own comment), so only Value has an edit
// affordance. Shared by the two admin pages that surface a slice of that
// table: Estimate Engine's "Takeoff Variables" tab (Category='room_boundary',
// the canvas's room-boundary/drawing-feel constants) and Basis of Design's
// Mechanical/HVAC tab (Category='hvac_duct_sizing', the Duct Estimator's
// design velocities). Extracted from BasisOfDesign.jsx on 2026-09-11 when
// the room-boundary tab moved to Estimate Engine.

const th = { fontSize: 11, fontWeight: 600, color: "var(--text3)", padding: "6px 8px", borderBottom: "1px solid var(--cs-border)", whiteSpace: "nowrap" };
const td = { padding: "6px 8px", borderBottom: "1px solid var(--cs-border)", fontSize: 12, verticalAlign: "top" };
const inputSm = { width: "100%", fontSize: 12, padding: "3px 6px", border: "1px solid var(--cs-border)", borderRadius: 4 };

export function TakeoffVariableRow({ row, editing, onEdit, onCancel, onSave }) {
  const [value, setValue] = useState(row.Value);
  useEffect(() => { if (editing) setValue(row.Value); }, [editing, row]);

  return (
    <tr>
      <td style={{ ...td, textAlign: "left" }}>
        <div style={{ fontWeight: 600 }}>{row.Label}</div>
        {row.Description && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{row.Description}</div>}
      </td>
      <td style={{ ...td, width: 110 }}>
        {editing
          ? <input type="number" step="any" autoFocus style={inputSm} value={value} onChange={e => setValue(e.target.value)} />
          : <span style={{ fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{row.Value}</span>}
      </td>
      <td style={{ ...td, textAlign: "right" }}>
        {editing ? (
          <>
            <button disabled={value === ""} onClick={() => onSave({ ...row, Value: value })} style={{ fontSize: 11, marginRight: 6, cursor: "pointer", fontWeight: 700 }}>Save</button>
            <button onClick={onCancel} style={{ fontSize: 11, cursor: "pointer" }}>Cancel</button>
          </>
        ) : (
          <button onClick={onEdit} style={{ fontSize: 11, cursor: "pointer" }}>Edit</button>
        )}
      </td>
    </tr>
  );
}

// The table shell both pages wrap the rows in — one place for the header
// row and the empty-state message.
export function TakeoffVariablesTable({ rows, editingKey, onEdit, onCancel, onSave, emptyText = "No takeoff variables yet." }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={{ ...th, textAlign: "left" }}>Variable</th>
          <th style={th}>Value</th>
          <th style={{ ...th, textAlign: "right" }}></th>
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <TakeoffVariableRow
            key={row.VariableKey}
            row={row}
            editing={editingKey === row.VariableKey}
            onEdit={() => onEdit(row.VariableKey)}
            onCancel={onCancel}
            onSave={onSave}
          />
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={3} style={{ ...td, textAlign: "center", color: "var(--text3)" }}>{emptyText}</td></tr>
        )}
      </tbody>
    </table>
  );
}
